import * as React from 'react'

import { Theme, withStyles } from '@material-ui/core/styles'

const styles = (theme: Theme): any => ({
  space: theme.mixins.toolbar,
})

interface Props {
  children?: React.ComponentType<{ className: string }>
  classes: any
}

const AppBarSpacing = ({ children, classes }: Props) => {
  switch (typeof children) {
    case 'function':
      const Component = children as React.ComponentType<{ className: string }>
      return (
        <Component className={classes.space} />
      )

    default: return (
      <div className={classes.space}>
        {children}
      </div>
    )
  }
}

export default withStyles(styles)(AppBarSpacing)



// WEBPACK FOOTER //
// ./src/components/atoms/AppBarSpacing.tsx